import { render } from "./MessageThreadUsers.vue?vue&type=template&id=d4c6d812&scoped=true"
import script from "./MessageThreadUsers.vue?vue&type=script&lang=js"
export * from "./MessageThreadUsers.vue?vue&type=script&lang=js"

import "./MessageThreadUsers.vue?vue&type=style&index=0&id=d4c6d812&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c6d812"]])

export default __exports__